import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  token: '', // مقدار اولیه
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setToken: (state, action) => {
      state.token = action.payload;
    },
    clearToken: (state) => {
      state.token = '';
    },
  },
});

export const { setToken, clearToken } = authSlice.actions;

